import AdminAxiosInstance from './AdminAxiosInstance'

const axiosInstance = AdminAxiosInstance

export const AdminReportsService = {
  getAdvanceVoteMailInExtract: async () => {
    try {
      const result = await axiosInstance.get(`/reports/adv-vote/vbm-report`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getElectionDayMailInExtract: async () => {
    try {
      const result = await axiosInstance.get(`/reports/by-vsd/vbm-report`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getCareFacilityMailInExtract: async () => {
    try {
      const result = await axiosInstance.get(`/reports/by-care-facility/vbm-report`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getCareFacilityPerExtract: async () => {
    try {
      const result = await axiosInstance.get(`/reports/by-care-facility/per-extract`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getElectionDayPerExtract: async () => {
    try {
      const result = await axiosInstance.get(`/reports/by-vsd/per-extract`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getStrikeOffByDay: async () => {
    try {
      const result = await axiosInstance.get(`/reports/strike-off/by-day`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getStrikeOffByDayByWard: async () => {
    try {
      const result = await axiosInstance.get(`/reports/strike-off/by-day/by-ward`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getStrikeOffByDayByPollingStation: async () => {
    try {
      const result = await axiosInstance.get(`/reports/strike-off/by-day/by-polling-station`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
}
